<div class="empty-location-container">
    <div class="empty-location-content">
        <div class="illustration">
            <img src="assets/images/package/Illustrations.svg" alt="No Locations" />
        </div>
        <div class="text-content">
            <h3>No locations to show!</h3>
            <p>Your saved locations will visible here. Start by adding one.</p>
        </div>
        <button class="btn btn-primary btn-medium" (click)="onAddLocation()">
            <img src="assets/images/package/plus.svg" alt="Add Location" />
            Add Location
        </button>
    </div>
</div>
